import { combineReducers, configureStore } from '@reduxjs/toolkit';

import reportContractFinancialStore from './contextRedux/ReportContractFinancial/ReportContractFinancialStore';
import reprotOfferFinancialStore from './contextRedux/ReportOfferFinancial/ReportOfferFinancialStore';
import reprotPMOfferFinancialStore from './contextRedux/ReportPMFinancial/ReportPMFinancialStore';

import accessControlEmployerModel from './contextRedux/AccessControlEmployer/AccessControlEmployerModel';
import accessControlEmployerStore from './contextRedux/AccessControlEmployer/AccessControlEmployerStore';

import accessControlDeviceModel from './contextRedux/AccessControlDevice/AccessControlDeviceModel';
import accessControlDeviceStore from './contextRedux/AccessControlDevice/AccessControlDeviceStore';

import accessControlEntryStore from './contextRedux/AccessControlEntry/AccessControlEntryStore';

import agentModel from './contextRedux/Agent/AgentModel';
import agentStore from './contextRedux/Agent/AgentStore';

import notificationModel from './contextRedux/Notification/NotificationModel';
import notificationStore from './contextRedux/Notification/NotificationStore';

import companyGroupModel from './contextRedux/CompanyGroup/CompanyGroupModel';
import companyGroupStore from './contextRedux/CompanyGroup/CompanyGroupStore';

import administrationCompanyModel from './contextRedux/AdministrationCompany/AdministrationCompanyModel';
import administrationCompanyStore from './contextRedux/AdministrationCompany/AdministrationCompanyStore';

import timeKeeperEntryStore from './contextRedux/TimeKeeperEntry/TimeKeeperEntryStore';

import timeKeeperEmployerModel from './contextRedux/TimeKeeperEmployer/TimeKeeperEmployerModel';
import timeKeeperEmployerStore from './contextRedux/TimeKeeperEmployer/TimeKeeperEmployerStore';

import timeKeeperSystemModel from './contextRedux/TimeKeeperSystemType/TimeKeeperSystemTypeModel';
import timeKeeperSystemStore from './contextRedux/TimeKeeperSystemType/TimeKeeperSystemTypeStore';

import timeKeeperDeviceModel from './contextRedux/TimeKeeperDevice/TimeKeeperDeviceModel';
import timeKeeperDeviceStore from './contextRedux/TimeKeeperDevice/TimeKeeperDeviceStore';

import companyModel from './contextRedux/Company/CompanyModel';
import companyStore from './contextRedux/Company/CompanyStore';
import companyTierStore from './contextRedux/Company/CompanyTierStore';
import contractModel from './contextRedux/Contract/ContractModel';
import deviceTypeModel from './contextRedux/DeviceType/DeviceTypeModel';
import deviceTypeStore from './contextRedux/DeviceType/DeviceTypeStore';
import infoDeviceModel from './contextRedux/InfoDevice/InfoDeviceModel';
import infoDeviceStore from './contextRedux/InfoDevice/InfoDeviceStore';
import productModel from './contextRedux/Product/ProductModel';
import productStore from './contextRedux/Product/ProductStore';

import systemInformationModel from './contextRedux/SystemInformation/SystemInformationModel';
import systemInformationStore from './contextRedux/SystemInformation/SystemInformationStore';

import laborModel from './contextRedux/Labor/LaborModel';
import laborStore from './contextRedux/Labor/LaborStore';

import laborExtraModel from './contextRedux/LaborExtra/LaborExtraModel';
import laborExtraStore from './contextRedux/LaborExtra/LaborExtraStore';

import additionalActModel from './contextRedux/AdditionalAct/AdditionalActModel';
import interventionFileModel from './contextRedux/InterventionFile/InterventionFileModel';
import interventionFileProjectModel from './contextRedux/InterventionFileProject/InterventionFileProjectModel';
import offerModel from './contextRedux/Offer/OfferModel';
import offerStore from './contextRedux/Offer/OfferStore';
import personContactStore from './contextRedux/PersonContact/PersonContactStore';
import pmAdditionalActModel from './contextRedux/PMAdditionalAct/PmAdditionalActModel';
import pmAdditionalActContractProjectModel from './contextRedux/PMAdditionalActContractProject/PmAdditionalActContractProjectModel';
import pmContractModel from './contextRedux/PMContract/PmContractModel';
import pmContractStore from './contextRedux/PMContract/PmContractStore';

import pmContractModelProject from './contextRedux/PMContractProject/PmContractModelProject';
import pmContractStoreProject from './contextRedux/PMContractProject/PmContractStoreProject';

import pmOfferModel from './contextRedux/PMOffer/PmOfferModel';
import pmOfferStore from './contextRedux/PMOffer/PmOfferStore';

import pmOfferModelProject from './contextRedux/PMOfferProject/PmOfferModelProject';
import pmOfferStoreProject from './contextRedux/PMOfferProject/PmOfferStoreProject';
import requestFileModel from './contextRedux/RequestFile/RequestFileModel';

import pmContractProjectStatusReducer from './contextRedux/PmContractProjectStatus/PmContractProjectStatusStore';
import pmContractStatusReducer from './contextRedux/PmContractStatus/PmContractStatusStore';
import pmOfferContractTypesReducer from './contextRedux/PmOfferContractTypes/PmOfferContractTypesStore';
import pmOfferProjectStatusReducer from './contextRedux/PmOfferProjectStatus/PmOfferProjectStatus';
import pmOfferStatusReducer from './contextRedux/PmOfferStatus/PmOfferStatusStore';
import requestFileStatusStore from './contextRedux/RequestFileStatus/RequestFileStatusStore';
import statusContractStore from './contextRedux/StatusContract/StatusContractStore';

import contractInterventionTariffTypeStore from './contextRedux/ContractInterventionTariffType/ContractInterventionTariffType';
import contractInterventionTypeStore from './contextRedux/ContractInterventionType/ContractInterventionType';

import interventionFileStore from './contextRedux/InterventionFile/InterventionFileStore';
import interventionFileProjectStore from './contextRedux/InterventionFileProject/InterventionFileProjectStore';

import providerModel from './contextRedux/Provider/ProviderModel';
import providerStore from './contextRedux/Provider/ProviderStore';

import contractStore from './contextRedux/Contract/ContractStore';
import providerGroupModel from './contextRedux/ProviderGroup/ProviderGroupModel';
import providerGroupStore from './contextRedux/ProviderGroup/ProviderGroupStore';

import mentenancePlanningModel from './contextRedux/MentenancePlanning/MentenancePlanningModel';
import mentenancePlanningStore from './contextRedux/MentenancePlanning/MentenancePlanningStore';
import providerWorkPlaceModel from './contextRedux/ProviderWorkPlace/ProviderWorkPlaceModel';
import providerWorkPlaceStore from './contextRedux/ProviderWorkPlace/ProviderWorkPlaceStore';
import statusOfferStore from './contextRedux/StatusOffer/StatusOfferStore';
import systemTypeModel from './contextRedux/SystemType/SystemTypeModel';
import systemTypeStore from './contextRedux/SystemType/SystemTypeStore';
import unitMeasureStore from './contextRedux/UnitMeasure/UnitMeasureStore';
import accountManagerStore from './contextRedux/User/AccountManagerStore';
import userModel from './contextRedux/User/UserModel';
import userRoleStore from './contextRedux/User/UserRoleStore';
import userStore from './contextRedux/User/UserStore';
import userGroupModel from './contextRedux/UserGroup/UserGroupModel';
import userGroupStore from './contextRedux/UserGroup/UserGroupStore';
import workPlaceModel from './contextRedux/WorkPlace/WorkPlaceModel';
import workPlaceStore from './contextRedux/WorkPlace/WorkPlaceStore';

import userAdministrationCompanyStore from './contextRedux/UserAdministrationCompany/UserAdministrationCompanyStore';

// Combine models reducers
const modelsReducer = combineReducers({
  accessControlEmployer: accessControlEmployerModel,
  accessControlDevice: accessControlDeviceModel,
  agent: agentModel,
  notification: notificationModel,
  offer: offerModel,
  pmOffer: pmOfferModel,
  pmOfferProject: pmOfferModelProject,
  pmContract: pmContractModel,
  pmContractProject: pmContractModelProject,
  contract: contractModel,
  pmAdditionalActContractProject: pmAdditionalActContractProjectModel,
  pmAdditionalAct: pmAdditionalActModel,
  additionalAct: additionalActModel,
  workPlace: workPlaceModel,
  providerWorkPlace: providerWorkPlaceModel,
  user: userModel,
  userGroup: userGroupModel,
  interventionFile: interventionFileModel,
  interventionProjectFile: interventionFileProjectModel,
  systemType: systemTypeModel,
  deviceType: deviceTypeModel,
  systemInformation: systemInformationModel,
  product: productModel,
  infoDevice: infoDeviceModel,
  labor: laborModel,
  laborExtra: laborExtraModel,
  requestFile: requestFileModel,
  providerGroup: providerGroupModel,
  provider: providerModel,
  administrationCompany: administrationCompanyModel,
  company: companyModel,
  companyGroup: companyGroupModel,
  timeKeeperEmployer: timeKeeperEmployerModel,
  timeKeeperSystem: timeKeeperSystemModel,
  timeKeeperDevice: timeKeeperDeviceModel,
  mentenancePlanning: mentenancePlanningModel,
});

// Combine store reducers
const storeReducer = combineReducers({
  reprotOfferFinancial: reprotOfferFinancialStore,
  reprotPMOfferFinancial: reprotPMOfferFinancialStore,
  reportContractFinancial: reportContractFinancialStore,
  accessControlEmployer: accessControlEmployerStore,
  accessControlDevice: accessControlDeviceStore,
  accessControlEntry: accessControlEntryStore,
  personContact: personContactStore,
  pmOfferContractType: pmOfferContractTypesReducer,
  pmOfferStatus: pmOfferStatusReducer,
  pmOfferProjectStatus: pmOfferProjectStatusReducer,
  pmContractStatus: pmContractStatusReducer,
  pmContractProjectStatus: pmContractProjectStatusReducer,
  unitMeasure: unitMeasureStore,
  offer: offerStore,
  pmOffer: pmOfferStore,
  systemType: systemTypeStore,
  deviceType: deviceTypeStore,
  systemInformation: systemInformationStore,
  product: productStore,
  contractInterventionType: contractInterventionTypeStore,
  contractInterventionTariffType: contractInterventionTariffTypeStore,
  statusContract: statusContractStore,
  statusOffer: statusOfferStore,
  user: userStore,
  userRole: userRoleStore,
  userGroup: userGroupStore,
  userAdministrationCompany: userAdministrationCompanyStore,
  administrationCompany: administrationCompanyStore,
  company: companyStore,
  provider: providerStore,
  requestFileStatus: requestFileStatusStore,
  infoDevice: infoDeviceStore,
  labor: laborStore,
  laborExtra: laborExtraStore,
  agent: agentStore,
  notification: notificationStore,
  contract: contractStore,
  pmContract: pmContractStore,
  pmContractProject: pmContractStoreProject,
  pmOfferProject: pmOfferStoreProject,
  workPlace: workPlaceStore,
  providerWorkPlace: providerWorkPlaceStore,
  providerGroup: providerGroupStore,
  companyGroup: companyGroupStore,
  companyTier: companyTierStore,
  accountManager: accountManagerStore,
  timeKeeperEmployer: timeKeeperEmployerStore,
  timeKeeperSystem: timeKeeperSystemStore,
  timeKeeperDevice: timeKeeperDeviceStore,
  timeKeeperEntry: timeKeeperEntryStore,
  interventionFile: interventionFileStore,
  interventionFileProject: interventionFileProjectStore,
  mentenancePlanning: mentenancePlanningStore,
});

const rootReducer = combineReducers({
  models: modelsReducer,
  store: storeReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === 'development' ? true : false,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
